module.exports = __webpack_public_path__ + "img/p_9.fd00dcd0.jpg";